import React from "react";
import { connect } from "react-redux";
import { getUsuario } from "../usuario/UsuarioService";
import axios from "axios";
import {
  URL,
  getAuthorizationHeader,
  idEmpresa,
  admin,
} from "../../constans/constants";
import Navbar from "../home/Navbar";
import "../../styles/Empresa.css";
import DocumentDialogContent from "../usuario/Usuario";
import UsuarioDatos from "../usuario/UsuarioDatos";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import { subirArchivoCsv } from "../usuario/UsuarioService";
import Cookies from "universal-cookie";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { Col, Container, Modal, Row,ModalFooter, Button } from "react-bootstrap";
import Dropzone from "react-dropzone";
import { logout } from "../login/SesionService";
import { obtenerListaEmpresas } from "../empresas/EmpresaService";
import { Form } from "react-bootstrap";
import ExclamacionIcon from "../../styles/icons/exclamation-circle.svg";
import delete_forever from "../../styles/icons/delete.svg";
import edit from "../../styles/icons/edit.svg";
import cloud_upload from "../../styles/icons/cloud_upload.svg";
import search from "../../styles/icons/search.svg";
import Spinner from "react-bootstrap/Spinner";
import checkCircle from '../../styles/icons/check-circle.svg';

export const obtenerIdEmpresa = () => {
  const cookies = new Cookies();
  return cookies.get("empresa");
};
export const esSesionAdmin = () => {
  const cookies = new Cookies();
  return cookies.get("admin") == "true";
};

class Usuarios extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: "Registrar Usuario",
      dialogType: "add",
      submitText: "Guardar",
      disabledInput: false,
      selectedUsuario: {
        usuario: "",
        identificador: "",
        nombres: "",
        apellidos: "",
        cedula: "",
        email: "",
        id: "",
      },
      file: null,
      filename: "",
      fileErrorMsg: "",
      dialogImportFromArchivo: false,
      dialogIsOpen: false,
      dialogIsOpenVerDatos: false,
      open: false,
      mostrarMensajeFlash: false,
      mensajeFlash: "",
      mensajeFlashSeverity: "success",
      roles: [],
      openPantallaCarga: false,
      severity: "success",
      listaEmpresas: null,
      listaEmpresaSelected: null,
      openMsgFailVentana: false,
      openMsgFinImportacion: false,
      erroresCsv: [],
      cantidadImportados: null,
      ultimoUsuarioImportado: null,

      expandedRow: null,
      pageSize: 10,
      loading: true,
      search: "",
    };
    this.tableRef = React.createRef();
    const cookies = new Cookies();
  }

  componentDidMount() {
    if (esSesionAdmin()) {
      obtenerListaEmpresas().then((res) => {
        this.state.listaEmpresas = res.datos;
        this.state.listaEmpresaSelected = res.datos[0].id;
      });
    }
    this.fetchUsuarios(0, this.state.pageSize, "");
  }

  handleDialog = (value, mensaje = "", severity) => {
    if (value === false) {
      this.fetchUsuarios(0, this.state.pageSize, "");
      if (mensaje != "") {
        this.setState({
          mostrarMensajeFlash: true,
          mensajeFlash: mensaje,
          severity: severity,
        });
      }
    }
    this.setState({ dialogIsOpen: value });
  };

  handleDialogVerDatos = (value) => {
    this.setState({
      dialogIsOpenVerDatos: value,
    });
  };

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  handleCloseMensajeFlash = () => {
    this.setState({
      mostrarMensajeFlash: false,
    });
  };

  handleDialogImportarUsuarios = (estado) => {
    if (esSesionAdmin() && this.state.listaEmpresas == null) {
      this.setState({ openMsgFailVentana: true });
      return;
    }
    if (!estado) {
      this.setState({ file: null, fileErrorMsg: "", filename: "" });
    }
    this.setState({ dialogImportFromArchivo: estado });
  };

  handleChangeSelect = (e) => {
    this.setState({ listaEmpresaSelected: e.target.value });
  };
  descargarXls = () => {
    let empresa = esSesionAdmin() ? -200 : obtenerIdEmpresa();
    window.location.href = URL + "usuario/xls/" + empresa;
  }
  onDrop = (files) => {
    this.setState({
      file: files[0],
      filename: files[0].name,
      fileErrorMsg: "",
    });
  };

  sendFile = () => {
    if (this.state.file != null) {
      if (this.state.file.type != "text/csv") {
        this.setState({
          fileErrorMsg: "* El archivo debe estar en formato .csv",
          file: this.state.file,
        });
      } else {
        this.setState({ openPantallaCarga: true });
        let data = new FormData();
        data.append("file", this.state.file);

        this.props.subirArchivoCsv(data, admin() ? this.state.listaEmpresaSelected : idEmpresa()).then(res => {
          this.setState({
            cantidadImportados: res.datos.cantidadImportados,
            ultimoUsuarioImportado: res.datos.ultimoUsuarioImportado,
            erroresCsv: res.datos.errores,
            openMsgFinImportacion: true,
            openPantallaCarga: false
          })
          this.handleDialogImportarUsuarios(false);
          this.fetchUsuarios(0, this.state.pageSize, "");
        })


      }
    } else {
      this.setState({
        fileErrorMsg: "*Debe subir un archivo en formato .csv",
        file: this.state.file,
      });
    }
  };

  handleDisableUsuario = () => {
    this.handleClose();
    this.setState({ openPantallaCarga: true });
    var empresa = obtenerIdEmpresa() != null ? obtenerIdEmpresa() : 0;
    axios
      .get(
        URL +
          "usuario/" +
          this.state.selectedUsuario.usuario +
          "/desactivar/empresa/" +
          empresa,
        getAuthorizationHeader()
      )
      .then(
        (response) => {
          this.setState({ openPantallaCarga: false });
          if (response.error) {
            this.setState({
              mensajeFlashSeverity: "danger",
            });
          } else {
            this.fetchUsuarios(this.state.page, this.state.pageSize, "");
          }
          this.setState({
            mensajeFlash: "Usuario deshabilitado con exito",
            mostrarMensajeFlash: true,
          });
        },
        (error) => {
          if (error.response.status === 401) {
            logout();
          }
          return error;
        }
      );
      this.fetchUsuarios(this.state.page, this.state.pageSize, "");
  };

  handleNewUsuario = () => {
    this.setState(
      {
        dialogTitle: "Registrar nuevo Usuario",
        selectedUsuario: {
          usuario: "",
          identificador: "",
          nombres: "",
          apellidos: "",
          cedula: "",
          email: "",
          id: "",
        },
        dialogType: "add",
        submitText: "Guardar",
        disabledInput: false,
      },
      () => {
        this.handleDialog(true);
      }
    );
  };

  handleMsgFailVentana = () => {
    this.setState({ openMsgFailVentana: false });
  };

  handleRowClick = (rowData) => {
    this.setState((prevState) => ({
      expandedRow:
        prevState.expandedRow === rowData.identificador
          ? null
          : rowData.identificador,
    }));
  };
  handlePageChange(newPage) {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchUsuarios(newPage, this.state.pageSize, "");
      });
    }
  }

  handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchUsuarios(this.state.page, this.state.pageSize, "");
      });
    }
  };

  handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize: newPageSize, page: 0 }, () => {
      this.fetchUsuarios(this.state.page, this.state.pageSize, "");
    });
  };

  renderPageNumbers() {
    const { page, totalPages } = this.state;
    const maxVisiblePages = 5; // Máximo de páginas visibles

    let pages = [];

    if (totalPages <= maxVisiblePages) {
      // Mostrar todas las páginas si son pocas
      for (let i = 0; i < totalPages; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }
    } else {
      // Mostrar primeras páginas, últimas y cercanas a la actual
      const startPage = Math.max(0, page - 2);
      const endPage = Math.min(totalPages - 1, page + 2);

      // Agregar primera página
      if (startPage > 0) {
        pages.push(
          <li
            key={0}
            className={`page-item ${page === 0 ? "active" : ""}`}
            onClick={() => this.handlePageChange(0)}
          >
            <a className="page-link" type="Button">1</a>
          </li>
        );
        if (startPage > 1) {
          pages.push(
            <li key="start-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
      }

      // Agregar páginas visibles
      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }

      // Agregar última página
      if (endPage < totalPages - 1) {
        if (endPage < totalPages - 2) {
          pages.push(
            <li key="end-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
        pages.push(
          <li
            key={totalPages - 1}
            className={`page-item ${page === totalPages - 1 ? "active" : ""}`}
            onClick={() => this.handlePageChange(totalPages - 1)}
          >
            <a className="page-link" type="Button">{totalPages}</a>
          </li>
        );
      }
    }

    return pages;
  }

  fetchUsuarios(page, pageSize, search) {
    this.setState({ loading: true });
    this.props.getUsuario(page, pageSize, search).then(() => {
      this.setState({
        usuarios: this.props.usuariosData.usuarios,
        page: this.props.usuariosData.page,
        totalCount: this.props.usuariosData.totalCount,
        totalPages: Math.ceil(this.props.usuariosData.totalCount / pageSize),
        loading: false,
      });
    });
  }

  handleSearchChange = (e) => {
    const searchValue = e.target.value;
    this.setState({ search: searchValue }, () => {
      this.fetchUsuarios(0, this.state.pageSize, this.state.search);
    });
  };

  handleMsgFinImportacion = () => {
    this.setState({ openMsgFinImportacion: false })
  }

  render() {
    return (
      <div>
        <div className="dashboardContent">
          <div className="container-fluid">
            <PantallaCarga open={this.state.openPantallaCarga} />

            <Modal
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.openMsgFinImportacion}
              onHide={this.handleMsgFinImportacion}
              backdrop="static"
              keyboard="false"

            >
              <Container>
                <Modal.Body>
                  <div>
                    <Row className="justify-content-center">
                      <Col className="text-center text-md-right">
                        <img src={this.state.erroresCsv.length > 0 ? checkCircle : ExclamacionIcon} style={{ margin: '40px' }}></img>
                      </Col>
                    </Row>
                    <Row className="justify-content-center">
                      <Col className="text-center text-md-right">
                        <p><strong>Importacion terminada</strong></p>
                      </Col>
                    </Row>
                    <Row style={{ background: "#F5F5F5", radius: "10px" }}>
                      <Col style={{ width: "483px", heigth: "27px", marginTop: "10px", left: "711px", textAlign: "center" }}>
                        <p>Usuarios importados: <strong>{this.state.cantidadImportados}</strong> {this.state.ultimoUsuarioImportado && <p> - Ultimo usuario importado: <strong>{this.state.ultimoUsuarioImportado}</strong></p>}</p>
                      </Col>
                    </Row>
                    {
                      this.state.erroresCsv.length > 0 &&
                      <Row>
                        <Col style={{
                          textAlign: "left", marginTop: "5px", marginLeft: "0px", width: '450px', height: '170px', overflowX: 'auto ',
                          padding: '10px'
                        }}>
                          <p><strong>Se encontraron los siguientes errores:</strong></p>
                          <div className="list-error">
                            {this.state.erroresCsv.map((error) =>
                              <li>{error}</li>
                            )}
                          </div>
                        </Col>
                      </Row>
                    }

                  </div>
                  <ModalFooter>
                    <Button variant="primary" onClick={this.handleMsgFinImportacion}>
                      Aceptar
                    </Button>
                  </ModalFooter>
                </Modal.Body>
              </Container>
            </Modal>

            <Modal
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.openMsgFailVentana}
              backdrop="static"
              keyboard="false"
            >
              <Container>
                <Modal.Body>
                  {
                    <div>
                      <Row className="justify-content-center">
                        <Col className="text-center text-md-right">
                          <i
                            className="bi bi-x-exclamation"
                            style={{ fontSize: "8rem", color: "#F44336" }}
                          ></i>
                        </Col>
                      </Row>
                      <Row className="justify-content-center">
                        <Col className="text-center text-md-right">
                          <p>
                            <strong>
                              Para importar usuarios, debe agregar al menos una
                              empresa primero{" "}
                            </strong>
                          </p>
                        </Col>
                      </Row>
                    </div>
                  }
                  <Modal.Footer>
                    <Button
                      variant="primary"
                      onClick={() => this.handleMsgFailVentana}
                    >
                      Aceptar
                    </Button>
                  </Modal.Footer>
                </Modal.Body>
              </Container>
            </Modal>

            <Modal
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.open}
              onHide={this.handleClose}
              backdrop="static"
              keyboard="false"
            >
              <Container>
                <Modal.Body>
                  <Row className="justify-content-center">
                    <Col className="text-center text-md-right">
                      <img
                        src={ExclamacionIcon}
                        style={{ margin: "40px" }}
                      ></img>
                    </Col>
                  </Row>
                  <Row className="justify-content-center">
                    <Col className="text-center text-md-right">
                      <p>
                        <strong>
                          Estas Seguro que desea eliminar el Usuario
                          seleccionado?
                        </strong>
                      </p>
                    </Col>
                  </Row>
                  <Row style={{ background: "#EDF2F9" }}>
                    <Col>
                      <p>
                        <strong>Identificador:</strong>{" "}
                        {this.state.selectedUsuario.identificador}
                      </p>
                      <p>
                        <strong>Nombre de Usuario: </strong>
                        {this.state.selectedUsuario.usuario}
                      </p>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={this.handleClose} variant="contained">
                    Cancelar
                  </Button>
                  <Button
                    onClick={this.handleDisableUsuario}
                    color="primary"
                    autoFocus
                  >
                    Aceptar
                  </Button>
                </Modal.Footer>
              </Container>
            </Modal>
            <Modal
              size="xl"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.dialogIsOpen}
              onHide={this.handleDialog}
              backdrop="static"
              keyboard="false"
            >
              <DocumentDialogContent
                usuario={this.state.selectedUsuario}
                handleClose={this.handleDialog}
                type={this.state.dialogType}
                submitText={this.state.submitText}
                disabledInput={this.state.disabledInput}
                dialogTitle={this.state.dialogTitle}
              />
            </Modal>

            <Modal
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.dialogImportFromArchivo}
              onHide={() => this.handleDialogImportarUsuarios(false)}
              backdrop="static"
              keyboard="false"
            >
              <Modal.Header>
                <Modal.Title style={{ color: "#0c56d0" }}>
                  Importar lista de usuarios
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Dropzone onDrop={this.onDrop}>
                  {({ getRootProps, getInputProps }) => (
                    <div>
                      <div
                        className="carga-documento-section"
                        style={{
                          border:
                            this.state.fileErrorMsg.length == 0
                              ? ""
                              : "1px solid red",
                        }}
                      >
                        <div className="carga-documento-content">
                          <img src={cloud_upload} alt="cloud_upload" />
                          <section className="container">
                            <div {...getRootProps({ className: "dropzone" })}>
                              <input {...getInputProps()} />
                              <p>Arrasta un archivo hasta aqui.</p>
                              <p className="text-small"> O si prefieres.. </p>
                              <a
                                className="local-upload btn btn-lg btn-primary-outline"
                                data-toggle="tooltip"
                                data-placement="top"
                                data-original-title="Desktop"
                              >
                                {" "}
                                Selecciona un archivo (solo en formato .csv)
                              </a>
                            </div>
                            <div style={{ marginBottom: "5px" }}>
                              <p
                                className="form-date"
                                style={{ color: "#3eba28" }}
                              >
                                {" "}
                                {this.state.filename}{" "}
                              </p>
                            </div>
                          </section>
                        </div>
                      </div>
                      <div style={{ marginTop: "1px" }}>
                        <small
                          style={{ color: "#f93154", alignContent: "left" }}
                        >
                          {this.state.fileErrorMsg}
                        </small>
                      </div>
                    </div>
                  )}
                </Dropzone>
                {esSesionAdmin && this.state.listaEmpresas != null && (
                  <div style={{ marginTop: "8px" }}>
                    <Form.Group className="form-group md-input">
                      <Form.Select
                        className="form-control md-select"
                        name="idGrupo"
                        id="idGrupo"
                        onChange={this.handleChangeSelect}
                        value={this.state.listaEmpresaSelected}
                        defaultValue={this.state.listaEmpresaSelected}
                        required
                      >
                        {this.state.listaEmpresas.map((elemento) => (
                          <option value={elemento.id} key={elemento.id}>
                            {elemento.nombre}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Label class="md-label">
                        {" "}
                        Seleccione una empresa{" "}
                      </Form.Label>
                    </Form.Group>
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  onClick={() => this.handleDialogImportarUsuarios(false)}
                  variant="contained"
                  color="primary"
                >
                  Cancelar
                </Button>
                <Button autoFocus color="primary" onClick={this.sendFile}>
                  Importar archivo
                </Button>
              </Modal.Footer>
            </Modal>
            <MensajeFlash
              mensaje={this.state.mensajeFlash}
              severity={this.state.severity}
              open={this.state.mostrarMensajeFlash}
              handleClose={this.handleCloseMensajeFlash}
            />
            <div className="sectionHeader">
              <h1 className="pageTitle"> Usuarios </h1>
              <div className="actions">
                <Button
                  style={{ backgroundColor: "#00B1C9" }}
                  onClick={this.handleNewUsuario}
                >
                  Nuevo Usuario
                </Button>
                <Button
                  color="primary"
                  style={{ marginLeft: "10px" }}
                  onClick={() => this.handleDialogImportarUsuarios(true)}
                >
                  Importar desde archivo
                </Button>
                <Button variant="success" onClick={this.descargarXls}>
                  Descargar XLS
                </Button>
              </div>
            </div>
            <Navbar
              menuActual={window.location.hash}
              seccionActual={"administracion"}
            />
            <div className="contentBuscador card">
              <form className="searchForm">
                <div className="input-group input-group-lg">
                  <span className="input-group-text border-0" id="basic-addon2">
                    <img src={search} />
                  </span>
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Buscar.."
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    value={this.state.search}
                    onChange={this.handleSearchChange}
                  />
                </div>
              </form>
            </div>
              <div className="contentPage card" style={{ padding: "0px" }}>
              {this.state.loading ? (
              // Muestra el spinner mientras loading sea true
              <div className="d-flex justify-content-center p-5">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Cargando...</span>
                </Spinner>
              </div>
            ) : (<div>
                <div className="customTable user-customTable">
                  <div className="customTable-head">
                    <div className="item-title">Identificador</div>
                    <div className="item-title">Nombre y Apellido</div>
                    <div className="item-title">Usuario</div>
                    <div className="item-title">Email</div>
                    <div className="item-title">Acciones</div>
                  </div>

                  <div className="customTable-body">
                    {this.props.usuariosData.usuarios.map((rowData) => (
                      <div
                        key={rowData.identificador}
                        className="customTable-item"
                      >
                        <div
                          className={`customTable-row accordion-button ${
                            this.state.expandedRow === rowData.identificador
                              ? ""
                              : "collapsed"
                          }`}
                          onClick={() => this.handleRowClick(rowData)}
                        >
                          <div className="item-info">
                            {rowData.identificador}
                          </div>
                          <div className="item-info">
                            {rowData.nombreApellido}
                          </div>
                          <div className="item-info">{rowData.usuario}</div>
                          <div className="item-info">{rowData.email}</div>
                          <div className="item-info">
                            <div className="table-actions">
                              <button
                                className="btn btn-secondary btn-md btn-floating"
                                onClick={() => {
                                  this.setState(
                                    {
                                      dialogTitle: "Editar Usuario",
                                      selectedUsuario: rowData,
                                      dialogType: "edit",
                                      submitText: "Editar",
                                      disabledInput: false,
                                    },
                                    () => {
                                      this.setState({
                                        mostrarMensajeFlash: false,
                                      });
                                      this.handleDialog(true);
                                    }
                                  );
                                }}
                              >
                                <img
                                  className="material-icons-outlined"
                                  src={edit}
                                />
                              </button>
                              <button
                                className="btn btn-secondary btn-md btn-floating"
                                onClick={() => {
                                  this.setState(
                                    {
                                      dialogTitle: "Ver Aplicación Externa",
                                      selectedUsuario: rowData,
                                      dialogType: "edit",
                                      submitText: "Editar",
                                      disabledInput: false,
                                    },
                                    () => {
                                      this.handleClickOpen();
                                    }
                                  );
                                }}
                              >
                                <img
                                  className="material-icons-outlined"
                                  src={delete_forever}
                                />
                              </button>
                            </div>
                          </div>
                        </div>

                        {this.state.expandedRow === rowData.identificador && (
                          <UsuarioDatos usuario={rowData} />
                        )}
                      </div>
                    ))}
                  <div id="paginador">
                    <label>
                      Mostrar
                      <select
                        className="form-control custom-select"
                        id="maxRows"
                        name="state"
                        value={this.state.pageSize}
                        onChange={this.handlePageSizeChange}
                      >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                      </select>
                      resultados.
                    </label>
                    <ul className="pagination mb-0">
                      <li
                        className={`page-item ${
                          this.state.page === 0 ? "disabled" : ""
                        }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page - 1)
                        }
                      >
                        <a className="page-link" type="Button">
                          <span className="material-icons">chevron_left</span>
                        </a>
                      </li>
                      {this.renderPageNumbers()}
                      <li
                        className={`page-item ${
                          this.state.page === this.state.totalPages - 1
                            ? "disabled"
                            : ""
                        }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page + 1)
                        }
                      >
                        <a className="page-link" type="Button">
                          <span className="material-icons">chevron_right</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                  </div>
                </div>
              </div>)}
              </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getUsuario: (page, size, search) => dispatch(getUsuario(page, size, search)),
  subirArchivoCsv: (file, idEmpresa) =>
    dispatch(subirArchivoCsv(file, idEmpresa)),
});

const mapStateToProps = (state) => ({
  usuariosData: state.usuariosData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Usuarios);
